
const AssetManagementIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.5 5V3.75C7.5 3.05964 8.05964 2.5 8.75 2.5H11.25C11.9404 2.5 12.5 3.05964 12.5 3.75V5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.75 5H16.25C16.9404 5 17.5 5.55964 17.5 6.25V15.625C17.5 16.3154 16.9404 16.875 16.25 16.875H3.75C3.05964 16.875 2.5 16.3154 2.5 15.625V6.25C2.5 5.55964 3.05964 5 3.75 5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 10.625C4.78125 11.7917 7.34375 12.5 10 12.5C12.6562 12.5 15.2188 11.7917 17.5 10.625"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.75 10H11.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default AssetManagementIcon
